"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "belvedere-marittimo": {
    "9317ddb0": [{
      "hkey": "a27688ea",
      "slug": "petrosa-alta",
      "name": "Petrosa Alta",
      "primary": true,
      "skipSearch": false
    }],
    "petrosa": [{
      "hkey": "a27688ea",
      "slug": "petrosa-alta",
      "name": "Petrosa Alta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0f937ec7": [{
      "hkey": "7a3935d2",
      "slug": "lido-sabbia-d-oro-santa-litterata",
      "name": "Lido Sabbia d'oro-Santa Litterata",
      "primary": true,
      "skipSearch": false
    }],
    "piano-delle-donne-santa-litterata": [{
      "hkey": "7a3935d2",
      "slug": "lido-sabbia-d-oro-santa-litterata",
      "name": "Lido Sabbia d'oro-Santa Litterata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "accb984e": [{
      "hkey": "c9ac427e",
      "slug": "trifari-alto",
      "name": "Trifari Alto",
      "primary": true,
      "skipSearch": false
    }],
    "trifari": [{
      "hkey": "c9ac427e",
      "slug": "trifari-alto",
      "name": "Trifari Alto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "2a077169": [{
      "hkey": "e671f080",
      "slug": "belvedere-marittimo",
      "name": "Belvedere Marittimo",
      "primary": true,
      "skipSearch": false
    }],
    "iannizzi": [{
      "hkey": "e671f080",
      "slug": "belvedere-marittimo",
      "name": "Belvedere Marittimo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "71ccd86f": [{
      "hkey": "8aee583c",
      "slug": "marina-di-belvedere",
      "name": "Marina di Belvedere",
      "primary": true,
      "skipSearch": false
    }],
    "marina": [{
      "hkey": "8aee583c",
      "slug": "marina-di-belvedere",
      "name": "Marina di Belvedere",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "172344cb": [{
      "hkey": "fdecbd5e",
      "slug": "oracchio",
      "name": "Oracchio",
      "primary": true,
      "skipSearch": false
    }],
    "oracchio-rocca-perrosa": [{
      "hkey": "fdecbd5e",
      "slug": "oracchio",
      "name": "Oracchio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "abd46c18": [{
      "hkey": "7a3935d2",
      "slug": "lido-sabbia-d-oro-santa-litterata",
      "name": "Lido Sabbia d'oro-Santa Litterata",
      "primary": true,
      "skipSearch": false
    }],
    "piano-la-donna": [{
      "hkey": "7a3935d2",
      "slug": "lido-sabbia-d-oro-santa-litterata",
      "name": "Lido Sabbia d'oro-Santa Litterata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6ad3829a": [{
      "hkey": "6ea5bbd0",
      "slug": "santo-ianni",
      "name": "Santo Ianni",
      "primary": true,
      "skipSearch": false
    }],
    "s-ianni": [{
      "hkey": "6ea5bbd0",
      "slug": "santo-ianni",
      "name": "Santo Ianni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "722ec655": [{
      "hkey": "7a3935d2",
      "slug": "lido-sabbia-d-oro-santa-litterata",
      "name": "Lido Sabbia d'oro-Santa Litterata",
      "primary": true,
      "skipSearch": false
    }],
    "santa-litterata": [{
      "hkey": "7a3935d2",
      "slug": "lido-sabbia-d-oro-santa-litterata",
      "name": "Lido Sabbia d'oro-Santa Litterata",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;